type MeasureTextOptions = {
  fontSize?: number;
  fontFamily?: string;
  lineContinuation?: string;
};
type MeasureText = (text: string, options?: MeasureTextOptions) => number;

const truncateText =
  (measureText: MeasureText) =>
  (text: string, maxWidth: number, options?: MeasureTextOptions) => {
    if (!text) {
      return '';
    }

    const textWidth = measureText(text, options);

    if (textWidth <= maxWidth) {
      return text;
    }

    const lineContinuation = options?.lineContinuation ?? '…';

    // Binary search with interpolation for faster convergence
    // IMPORTANT: We measure text+lineContinuation together to account for kerning/ligatures
    let a = 0;
    let aWidth = 0; // Width of text.substring(0, a) + lineContinuation
    let b = text.length;
    let bWidth = textWidth; // Width of full text (without lineContinuation)

    while (b - a > 1) {
      // Linear interpolation: estimate where the cutoff should be
      // p represents the portion of remaining width we've achieved
      const widthDiff = bWidth - aWidth;
      const p = widthDiff > 0 ? (maxWidth - aWidth) / widthDiff : 0.5;
      // interp(p, a, b) = a * (1 - p) + b * p
      const interpolated = a * (1 - p) + b * p;
      const c = Math.max(a + 1, Math.min(b - 1, Math.round(interpolated)));

      const testText = `${text.substring(0, c)}${lineContinuation}`;
      const cWidth = measureText(testText, options);

      if (cWidth > maxWidth) {
        b = c;
        bWidth = cWidth;
      } else {
        a = c;
        aWidth = cWidth;
      }
    }

    return `${text.substring(0, a).trimEnd()}${lineContinuation}`;
  };
export { truncateText };
